import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors';
import * as background from '../../config/backgroundColor';
import * as legend from '../../config/legend';
import * as series from '../../config/series';
import * as toolbox from '../../config/toolbox'
import * as tooltip from '../../config/tootip'
import * as axisPointer from '../../config/axisPointer';
import * as xAxis from '../../config/xAxis'
import * as yAxis from '../../config/yAxis'
import * as grid from '../../config/grid';
import { EChartOption } from 'echarts';
import { ChartOptionService } from '../../service/chart-option.service';
import { IndexGaugeComponent } from './index-gauge.component'
import { componentFactoryName } from '@angular/compiler';
import { cloneDeep, isNil } from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class IndexGaugeService {

  constructor(
    private chartOptionService: ChartOptionService
  ) { }

  getDefaultGaugeService(): EChartOption.SeriesGauge {

    let gaugeSeries = this.chartOptionService.getDefaultGaugeSeries();
    return gaugeSeries;
  }

  changeChartTitleDark(IndexGaugeComponent: IndexGaugeComponent, darkMode: boolean) {
    if (darkMode) {
      IndexGaugeComponent.chartTitleColor = color.darkModeTextColor;
      IndexGaugeComponent.cardBgColor = background.darkModeBGColor;
    }
  }

  chartBackgroundColorDarkMode(backgroundColorOption) {
    backgroundColorOption.backgroundColor = background.darkModeBGColor;
  }

  colorsDarkMode(colors: string[]) {
    colors.length = 0;
    color.darkModeColors.forEach(e => {
      colors.push(e);
    });
  }

  chartColorsChange(colors: string[], colorList: string[]) {
    colors.length = 0;
    colorList.forEach(e => {
      colors.push(e);
    });
  }

  seriesDarkMode(seriesOption: EChartOption.Series) {
    if (isNil(seriesOption['label'])) {
      seriesOption['label'] = {};
    }
    seriesOption['label']['color'] = color.darkModeTextColor;
  }

  setInterval(option: any, interval: Number) {
    option.xAxis[0].axisLabel.interval = interval;
  }


  buildSeries(chartData: any, seriesList: EChartOption.Series[], gaugeSeriesOption: EChartOption.SeriesGauge) {
    seriesList.length = 0;
    if (chartData && chartData.hasOwnProperty('data')) {
      gaugeSeriesOption.data = [{ name: '', value: chartData.data }];

    }

    if (chartData && chartData.hasOwnProperty('seriesName')) {
      gaugeSeriesOption.name = chartData.seriesName
    }

    seriesList.push(gaugeSeriesOption);
  }



  setSmallModePadding(compent: IndexGaugeComponent) {
    compent.cardPadding = "0rem";
  }

  setSeriesMin(gaugeSeriesOption: EChartOption.SeriesGauge, min: number) {
    gaugeSeriesOption.min = min;
  }

  setSeriesMax(gaugeSeriesOption: EChartOption.SeriesGauge, max: number) {
    gaugeSeriesOption.max = max;
  }

  // 分隔线
  setSplitLine(gaugeSeriesOption: EChartOption.SeriesGauge, splitLineSwitch: boolean) {
    if (splitLineSwitch) {
      gaugeSeriesOption.splitLine.show = true;
    } else {
      gaugeSeriesOption.splitLine.show = false;
    }
  }

  // 设置刻度
  setAxisTick(gaugeSeriesOption: EChartOption.SeriesGauge, axisTickSwitch: boolean) {
    if (axisTickSwitch) {
      gaugeSeriesOption.axisTick.show = true;
    } else {
      gaugeSeriesOption.axisTick.show = false;
    }
  }

  // 数据显示文字
  setDetailText(detailText, gaugeSeriesOption: EChartOption.SeriesGauge, chartTooltipOption: EChartOption.Tooltip) {

    let temArr = [
      `{c|{value}}`
    ];

    if (detailText.number && detailText.unit) {
      temArr.push(`{a| ${detailText.number !== null ? detailText.number : '--'} }{b| ${detailText.unit !== null ? detailText.unit : ''}  }`)
    }
    if (detailText.itemText) {
      temArr.push(`{a| ${detailText.itemText} }`)
    }

    gaugeSeriesOption.detail.formatter = temArr.join('\n')
    chartTooltipOption.formatter = this.chartOptionService.getTooltipOfIndexGauge(detailText).formatter;
  }

  // label 分隔数
  setSplitNumber(gaugeChartSeries: EChartOption.SeriesGauge, splitNum: number) {
    gaugeChartSeries.splitNumber = splitNum;
  }

  setColorRange(gaugeChartSeries: EChartOption.SeriesGauge, colorRange: any) {
    gaugeChartSeries.axisLine.lineStyle.color = colorRange;
  }

  setAxisLabel(gaugeChartSeries: EChartOption.SeriesGauge, labelSwitch: boolean) {
    if (labelSwitch) {
      gaugeChartSeries.axisLabel.show = true;
    } else {
      gaugeChartSeries.axisLabel.show = false;
    }
  }

  setRadius(gaugeChartSeries: EChartOption.SeriesGauge, radius: number | string) {
    gaugeChartSeries.radius = radius;
  }

}
